export default "__VITE_PUBLIC_ASSET__c0bc6bee__"